import React from 'react';
import SearchBlock from '../platformui/SearchBlock';
export default (props) => (
  <SearchBlock {...props} hasNoAutocomplete={true} hasQuickSearch={true} />
);
